import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class SquareLocationId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): SquareLocationId {
    return new SquareLocationId(value);
  }
}
